module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_clear_mobile.26a90284.jpg";